import { useApiSubmit } from '@hooks/use-api-submit';
import type { IStartSurveyResult, IStartSurveyResults } from '@/types/surveys/start-survey';

const START_SURVEY_ENDPOINT = '/api/register/start-survey';

export const useStartSurvey = (registrationId: number, editKey: string) => {
    const url = `${START_SURVEY_ENDPOINT}/${registrationId}/${editKey}`;

    const { submit, isSubmitting, submitError } = useApiSubmit<void, IStartSurveyResults, IStartSurveyResult>(
        url,
        () => ({}),
        (results) => ({
            redirectUrl: results?.redirectUrl ?? null,
            nextStep: results?.nextStep ?? null,
        }),
        'We were not able to open your survey. Please try again.',
    );

    return { start: submit, isStarting: isSubmitting, error: submitError };
};
